export enum OutlookSyncStatus {
  NotStarted = 1,
  InProgress = 2,
  Completed = 3,
  Failed = 4
}
